export default String.raw`
.blog-post {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    &__main {
        display: flex;
        flex-wrap: nowrap;
        flex-direction: row;
        width: 100%;
        padding: 0 130px 32px 130px;
        gap: 24px;
    }

    &__article {
        display: flex;
        flex-direction: column;
        width: 76%;
        gap: 16px;
    }

    &__sidebar {
        width: 24%;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        gap: 16px;

        .swiper-wrapper {
            display: flex;
            flex-direction: column;
        }
    }

    &__all-articles {
        display: flex;
        @include h3-headline;

        &-link {
            display: flex;
            align-items: center;

            &:focus-visible {
                outline-offset: -1px;
            }
        }

        svg {
            margin: 16px;
            fill: $iconColors;
        }
    }
}

.article {
    &__header {
        display: flex;
        flex-direction: column;
        gap: 16px;

        h1 {
            @include h2-headline;
            word-break: break-word;
        }
    }

    &__metadata {
        display: flex;
        justify-content: space-between;
        width: 100%;
        @include body-2-regular;

        &-time {
            display: flex;
            gap: 16px;
            color: $dateOfPublication;
        }
    }

    &__image {
        text-align: center;

        img {
            max-height: 100%;
            max-width: 100%;
            margin: auto;
            border-radius: 10px;
        }
    }

    &__content {
        width: 100%;

        * {
            margin: revert;
            padding: revert;
            list-style: revert;
        }
    }

    &__footer {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;

        &-share {
            display: flex;
            align-items: center;
            justify-content: center;
            border: 1px solid $iconColors;
            border-radius: 5px;
            gap: 16px;
            padding: 0 24px;
            height: 48px;
            white-space: nowrap;
            @include body-1-medium;

            svg {
                display: flex;
                align-items: center;
                fill: $iconColors;
            }
        }
    }
}

.sidebar {
    &__header {
        padding: 16px;
    }
    
    .blog-item {
        height: auto;
        padding: 0 16px 16px 16px;
    
        &__right-section {
            display: flex;
            flex-direction: column;
            flex-wrap: nowrap;
    
            &-wrapper {
                justify-content: space-between;
                
                span {
                    display: none;
                    @include body-2-regular;
                    color: $dateOfPublication;
                    white-space: nowrap;
                }
            }
        }
    }
    
    &__next-article,
    &__latests-posts {
        border: 1px solid $lightBorderColor;
        border-radius: 10px;
    }
    
    &__latests-posts {
        .blog-item {
            &__wrapper {
                gap: 12px;
                flex-direction: column;
            }
    
            &__title {
                margin: 0;
                overflow: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                line-clamp: 2; 
                -webkit-box-orient: vertical;
                white-space: unset;
                @include body-1-medium;
            }
    
            &__read {
                display: none;
            }
    
            &__content {
                display: none;
            }
        }
    }
}

`